import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getStudentBreakdownDetails, getStudentBreakdowns, getStudentPayments } from '../api/payments.api';
import { IStudentPayment, IGetStudentPayments, IStudentBreakdown, IStudentBreakdownDetail, IGetStudentBreakdowns, IGetStudentBreakdownDetails } from '../models/payments.model';

interface IStudentPaymentState {
  studentPayments: IStudentPayment[];
  studentBreakdowns: IStudentBreakdown[];
  studentBreakdownDetails: IStudentBreakdownDetail[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IStudentPaymentState = {
  studentPayments: [],
  studentBreakdowns: [],
  studentBreakdownDetails: [],
  isLoading: false
};

const studentPaymentSlicer = createSlice({
  name: 'studentPayment',
  initialState,
  reducers: {
    getStudentPaymentsStart: (state: IStudentPaymentState) => {
      state.studentPayments = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentPaymentsSuccess: (state: IStudentPaymentState, action: PayloadAction<IGetStudentPayments>) => {
      state.studentPayments = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentPaymentsFailure: (state: IStudentPaymentState, action: PayloadAction<AxiosError | string>) => {
      state.studentPayments = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    getStudentBreakdownsStart: (state: IStudentPaymentState) => {
      state.studentBreakdowns = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentBreakdownsSuccess: (state: IStudentPaymentState, action: PayloadAction<IGetStudentBreakdowns>) => {
      state.studentBreakdowns = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentBreakdownsFailure: (state: IStudentPaymentState, action: PayloadAction<AxiosError | string>) => {
      state.studentBreakdowns = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    getStudentBreakdownDetailsStart: (state: IStudentPaymentState) => {
      state.studentBreakdownDetails = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getStudentBreakdownDetailsSuccess: (state: IStudentPaymentState, action: PayloadAction<IGetStudentBreakdownDetails>) => {
      state.studentBreakdownDetails = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getStudentBreakdownDetailsFailure: (state: IStudentPaymentState, action: PayloadAction<AxiosError | string>) => {
      state.studentBreakdownDetails = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IStudentPaymentState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IStudentPaymentState, action: PayloadAction<AxiosError | string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    requestSuccess: (state: IStudentPaymentState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    createSuccess: (state: IStudentPaymentState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    // updateSuccess: (state: IStudentPaymentState) => {
    //   state.isLoading = false;
    //   state.error = undefined;
    // },
    // deleteSuccess: (state: IStudentPaymentState) => {
    //   state.isLoading = false;
    //   state.error = undefined;
    // }
  }
});

export const {
  getStudentPaymentsStart,
  getStudentPaymentsSuccess,
  getStudentPaymentsFailure,
  getStudentBreakdownsStart,
  getStudentBreakdownsSuccess,
  getStudentBreakdownsFailure,
  getStudentBreakdownDetailsStart,
  getStudentBreakdownDetailsSuccess,
  getStudentBreakdownDetailsFailure,
  requestStart,
  requestFailure,
  requestSuccess,
  createSuccess,
  // updateSuccess,
  // deleteSuccess
} = studentPaymentSlicer.actions;

export default studentPaymentSlicer.reducer;

export const doGetStudentPayments = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getStudentPaymentsStart());
    const response = await getStudentPayments(memberCode);
    dispatch(getStudentPaymentsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getStudentPaymentsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetStudentBreakdowns = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getStudentBreakdownsStart());
    const response = await getStudentBreakdowns(memberCode);
    dispatch(getStudentBreakdownsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getStudentBreakdownsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetStudentBreakdownDetails = (paymentRecordCode: number): any => async (dispatch: any) => {
  try {
    dispatch(getStudentBreakdownDetailsStart());
    const response = await getStudentBreakdownDetails(paymentRecordCode);
    dispatch(getStudentBreakdownDetailsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getStudentBreakdownDetailsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
